import { z } from 'zod';

export const ticketFormSchema = z.object({
    subject: z.string().trim().min(3, 'Escreva um assunto com pelo menos 3 letras').max(120, 'O assunto pode ter no máximo 120 caracteres'),
    body: z.string().trim().min(10, 'Descreva melhor o pedido (pelo menos 10 letras)').max(4000, 'A mensagem pode ter no máximo 4000 caracteres'),
});

export type TicketFormValues = z.infer<typeof ticketFormSchema>;
